import { Component, OnInit } from '@angular/core';

import { SurveyCreatorModel } from "survey-creator-core";

import "survey-core/survey.i18n.js";
import "survey-creator-core/survey-creator-core.i18n.js";

import { surveyLocalization } from 'survey-core';

import { ComponentCollection } from "survey-core";
import { Serializer } from "survey-core";
import {  MenuItem, MessageService, SelectItem } from 'primeng/api';
import { localization } from "survey-creator-core";
import { ApiService } from 'src/app/_services/api.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalService } from 'src/app/_services/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import * as moment from 'moment';



@Component({
  selector: 'app-survey-edit',
  templateUrl: './survey-edit.component.html',
  styleUrls: ['./survey-edit.component.css'],
  providers: [ MessageService]
})

export class SurveyEditComponent implements OnInit {

  surv:any={status:'READY'};
  
  targetsList:any[] = [];
  rsaList:any[] = [];
  modelsList:any[] = [];
  statusList:SelectItem[] = [];
  companyList:SelectItem[] = [];
 
  action='';  
  id:number;
  breadcrumbs: MenuItem[];

  errors: {
    DescrizioneError: boolean,

  };
  constructor(
    private apiService: ApiService,
    private messageService: MessageService,
    private translate: TranslateService,
    private globalService: GlobalService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }


  ngOnInit(): void {
    this.populateBreadcrumb();
    this.initErrors();  

    this.statusList.push({label:'DRAFT',value:'DRAFT'});
    this.statusList.push({label:'READY',value:'READY'});
    this.companyList.push({label:'Please select ...',value:''});
    this.companyList.push({label:'AMAVIR',value:'AMAVIR'});
    this.companyList.push({label:'DOREAFAMILIE',value:'DOREAFAMILIE'});
    this.companyList.push({label:'DOREACLIENTS',value:'DOREACLIENTS'});
    this.companyList.push({label:'DOREAEMPLOYEES',value:'DOREAEMPLOYEES'});
    this.companyList.push({label:'GRUPPO LA VILLA',value:'LA_VILLA'});
    this.companyList.push({label:'MAISON DE FAMILLE',value:'MAISON_DE_FAMILLE'});
    this.surv.company=this.companyList[0];

    let params: any = {PageSize : 10000};
 
    this.action=this.route.snapshot.paramMap.get('action');
    this.id=null;
    
   
    let rsal=this.apiService.get('surveys-rsa/listall',{});
    let targets=this.apiService.get('surveys-targets/listall',{});
    let modelsl=this.apiService.get('surveys-models/listall',{});
    
    this.rsaList.push({name:'Please select ...',id:''});
    this.targetsList.push({name:'Please select ...',id:''});
    this.modelsList.push({name:'Please select ...',id:''});

    forkJoin([ rsal,targets,modelsl]).subscribe(data => {
      this.rsaList=this.rsaList.concat(data[0].Result) ;
      this.targetsList=this.targetsList.concat(data[1].Result) ;
      this.modelsList=this.modelsList.concat(data[2].Result) ;
      if(this.targetsList.length>0){
        this.surv.target=this.targetsList[0];
      }
      if(this.modelsList.length>0){
        this.surv.model=this.modelsList[0];
      }
      if(this.rsaList.length>0){
        this.surv.rsa=this.rsaList[0];
      }
      this.surv.status=this.statusList[0].value;
      if (this.route.snapshot.paramMap.get('id')) {
      
        this.id=parseInt(this.route.snapshot.paramMap.get('id'));
        params={'id':this.id};
        this.apiService.get('surveys/listall',params).subscribe(data => {
          for (const g of data.Result) {
            if(g['id']==this.id){
              this.surv=g;
              
              this.surv.date_end=new Date(this.surv.date_end);
              this.surv.date_start=new Date(this.surv.date_start);
      
              if(g.archived==1){
                this.surv.archived=true;
              }

            }
          }
      
        });
     
    
      }
      if(!this.surv.status){
        this.surv.status=this.statusList[0];
      }
    });
 
  }
 
  
  private initErrors() {
    this.errors = {} as any;
  }
 

  private validate() : boolean {
    let isValid : boolean = true;
    
    if (!this.surv.name) {
      this.addSingle('error', 'Error', 'Title field is required');
       isValid = false;
      
    }
        
    if ((!this.surv.company)||(this.surv.company.value=='')) {
      this.addSingle('error', 'Error', 'Company field is required');
       isValid = false;
      

    }
    
    
 
    if ((!this.surv.target_id)||(this.surv.target_id=='')) {
      this.addSingle('error', 'Error', 'Target field is required');
       isValid = false;
      
    }
    if ((!this.surv.model_id)||(this.surv.model_id=='')) {
      this.addSingle('error', 'Error', 'Model field is required');
       isValid = false;
      
    }
    if ((!this.surv.rsa_list_id)||(this.surv.rsa_list_id=='')) {
      this.addSingle('error', 'Error', 'Residencies list field is required');
       isValid = false;
      
    }
    return isValid;
  }


  public save() {
    
      this.initErrors();
      if (!this.validate()) return;
      if(this.surv.date_start){
        this.surv.date_start =  moment(this.surv.date_start).format("YYYY-MM-DD");
      }
    
      if(this.surv.date_end){
         this.surv.date_end =  moment(this.surv.date_end).format("YYYY-MM-DD");
      }
    
    
      
      this.apiService.updateSurvey(this.surv).subscribe(data => {
        this.addSingle('success', 'Successo', 'Survey saved');
        this.router.navigateByUrl('/dashboard/surveys/surveys');
      });
  

  }
 

  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }

  private populateBreadcrumb() {
    this.translate.get('breadcrumb').subscribe(labels => {
      this.breadcrumbs = [
        { icon: 'fas fa-home', routerLink: '/dashboard' },
         { label: 'Survey'},
      ];
    });
  }


}
